import axios from "../../axios-auth";
import { makeQueryFromObject } from "../../helpers/helpers";
import { i18n } from "../../i18n.js";

const state = {
  personalizeLoading: false,
  beforePersonalizeCallback: null
};

const getters = {
  getPersonalizeLoading: state => {
    return state.personalizeLoading;
  },
  getBeforePersonalizeCallback: state => {
    return state.beforePersonalizeCallback;
  }
};

const mutations = {
  setPersonalizeLoading: (state, payload) => {
    state.personalizeLoading = payload;
  },
  setBeforePersonalizeCallback: (state, payload) => {
    state.beforePersonalizeCallback = payload;
  }
};

const actions = {
  getPersonalizeUrl: (
    { commit, getters, dispatch, state, rootState },
    payload
  ) => {
    var params = payload.params;
    if (getters.getBeforePersonalizeCallback) {
      params = getters.getBeforePersonalizeCallback(payload.params);
      if (!params) {
        return;
      }
    }

    commit("setPersonalizeLoading", true);

    axios.instance
      .get(getters.getUrl(axios.getPersonalizeUrl), {
        params
      })
      .then(response => {
        const { data } = response;
        if (data) {
          const { success } = data;
          if (success) {
            const { url } = data;
            const { personalizationCB } = payload;
            if (typeof personalizationCB === "function") {
              personalizationCB(url);
              if (payload.params.isPersonalizationNewPage) {
                // in this case do not close the loading
                return;
              }
            }
          } else {
            const { message } = data;
            payload.wnd.$swal({
              text: message,
              icon: "error"
            });
          }
        }
        commit("setPersonalizeLoading", false);
      })
      .catch(error => {
        payload.wnd.$swal({
          text: "Error " + error,
          icon: "error"
        });
        commit("setPersonalizeLoading", false);
      });
  },
  setBeforePersonalizeCallback: ({ commit, getters, dispatch }, payload) => {
    commit("setBeforePersonalizeCallback", payload);
  },
  setPersonalizeLoading: ({ commit, getters, dispatch }, payload) => {
    commit("setPersonalizeLoading", payload);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
